"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _utils = require("@site/utils");
const UIHelper = {
  getLpSpinHeader: (emd = {}) => {
    if (emd.IsAvailable && emd.AvailabilityLabel === _utils.AvailabilityStatus.Premium) {
      return 'notQualifiedForOfferSpinHdr';
    } else if (emd.IsAvailable && emd.AvailabilityLabel === _utils.AvailabilityStatus.RegPremium) {
      return 'notQualifiedForOfferSpinHdr';
    } else if (emd.AvailabilityLabel === _utils.AvailabilityStatus.Auction) {
      return 'howAboutThese';
    } else if (emd.AvailabilityLabel === _utils.AvailabilityStatus.Taken && emd.IsDbsAvailable) {
      return 'howAboutThese';
    } else if (emd.IsAvailable && !emd.IsPurchasable) {
      return 'howAboutThese';
    }
    return 'protectYourName';
  }
};
var _default = exports.default = UIHelper;